import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideHttpClient } from '@angular/common/http'; // 1. Importar HttpClient provider
import { RouterModule } from '@angular/router';

import { AppComponent } from './app.component';
import { CotizadorPageComponent } from './features/cotizador/pages/cotizador-page/cotizador-page.component';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    RouterModule.forRoot([]), 
    CotizadorPageComponent    
  ],
  providers: [
    provideHttpClient()       
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }